// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"dbbe7bee","453":"ce449618"}[chunkId] + ".chunk.js";
};